function extractDomain(hostname) {
	if (hostname.substring(0, 4) === 'www.') {
		return hostname.substring(4, hostname.length);
	}
	return hostname;
}

function newGuid() {
	function s4() {
		// eslint-disable-next-line no-magic-numbers
		return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	}
	return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}

export default class {
	constructor(cookies, href, ref) {
		this.cookies = cookies;
		this.href = href;
		this.ref = ref;

		this.hrefCookieName = 'bpmHref';
		this.refCookieName = 'bpmRef';
		this.obsoleteCookieName = 'bpmSessionId';
		this.trackingIdCookieName = 'bpmTrackingId';
		this.expiresCookieDays = 180;
		this.TLDs = [
			'ac', 'ad', 'ae', 'aero', 'af', 'ag', 'ai', 'al', 'am', 'an', 'ao', 'aq', 'ar', 'arpa', 'as', 'asia', 'at', 'au', 'aw', 'ax', 'az', 'ba', 'bb', 'bd', 'be', 'bf', 'bg', 'bh', 'bi', 'biz', 'bj', 'bm', 'bn', 'bo', 'br', 'bs', 'bt', 'bv', 'bw', 'by', 'bz', 'ca', 'cat', 'cc', 'cd', 'cf', 'cg', 'ch', 'ci', 'ck', 'cl', 'cm', 'cn', 'co', 'com', 'coop', 'cr', 'cu', 'cv', 'cx', 'cy', 'cz', 'de', 'dj', 'dk', 'dm', 'do', 'dz', 'ec', 'edu', 'ee', 'eg', 'er', 'es', 'et', 'eu', 'fi', 'fj', 'fk', 'fm', 'fo', 'fr', 'ga', 'gb', 'gd', 'ge', 'gf', 'gg', 'gh', 'gi', 'gl', 'gm', 'gn', 'gov', 'gp', 'gq', 'gr', 'gs', 'gt', 'gu', 'gw', 'gy', 'hk', 'hm', 'hn', 'hr', 'ht', 'hu', 'id', 'ie', 'il', 'im', 'in', 'info', 'int', 'io', 'iq', 'ir', 'is', 'it', 'je', 'jm', 'jo', 'jobs', 'jp', 'ke', 'kg', 'kh', 'ki', 'km', 'kn', 'kp', 'kr', 'kw', 'ky', 'kz', 'la', 'lb', 'lc', 'li', 'lk', 'lr', 'ls', 'lt', 'lu', 'lv', 'ly', 'ma', 'mc', 'md', 'me', 'mg', 'mh', 'mil', 'mk', 'ml', 'mm', 'mn', 'mo', 'mobi', 'mp', 'mq', 'mr', 'ms', 'mt', 'mu', 'museum', 'mv', 'mw', 'mx', 'my', 'mz', 'na', 'name', 'nc', 'ne', 'net', 'nf', 'ng', 'ni', 'nl', 'no', 'np', 'nr', 'nu', 'nz', 'om', 'org', 'pa', 'pe', 'pf', 'pg', 'ph', 'pk', 'pl', 'pm', 'pn', 'pr', 'pro', 'ps', 'pt', 'pw', 'py', 'qa', 're', 'ro', 'rs', 'ru', 'rw', 'sa', 'sb', 'sc', 'sd', 'se', 'sg', 'sh', 'si', 'sj', 'sk', 'sl', 'sm', 'sn', 'so', 'sr', 'st', 'su', 'sv', 'sy', 'sz', 'tc', 'td', 'tel', 'tf', 'tg', 'th', 'tj', 'tk', 'tl', 'tm', 'tn', 'to', 'tp', 'tr', 'travel', 'tt', 'tv', 'tw', 'tz', 'ua', 'ug', 'uk', 'us', 'uy', 'uz', 'va', 'vc', 've', 'vg', 'vi', 'vn', 'vu', 'wf', 'ws', 'xn--0zwm56d', 'xn--11b5bs3a9aj6g', 'xn--3e0b707e', 'xn--45brj9c', 'xn--80akhbyknj4f', 'xn--90a3ac', 'xn--9t4b11yi5a', 'xn--clchc0ea0b2g2a9gcd', 'xn--deba0ad', 'xn--fiqs8s', 'xn--fiqz9s', 'xn--fpcrj9c3d', 'xn--fzc2c9e2c', 'xn--g6w251d', 'xn--gecrj9c', 'xn--h2brj9c', 'xn--hgbk6aj7f53bba', 'xn--hlcj6aya9esc7a', 'xn--j6w193g', 'xn--jxalpdlp', 'xn--kgbechtv', 'xn--kprw13d', 'xn--kpry57d', 'xn--lgbbat1ad8j', 'xn--mgbaam7a8h', 'xn--mgbayh7gpa', 'xn--mgbbh1a71e', 'xn--mgbc0a9azcg', 'xn--mgberp4a5d4ar', 'xn--o3cw4h', 'xn--ogbpf8fl', 'xn--p1ai', 'xn--pgbs0dh', 'xn--s9brj9c', 'xn--wgbh1c', 'xn--wgbl6a', 'xn--xkc2al3hye2a', 'xn--xkc2dl3a5ee0h', 'xn--yfro4i67o', 'xn--ygbi2ammx', 'xn--zckzah', 'xxx', 'ye', 'yt', 'za', 'zm', 'zw',
		].join();
	}

	get expires() {
		const date = new Date();
		date.setTime(date.getTime() + (this.expiresCookieDays * 24 * 60 * 60 * 1000));
		return date;
	}

	get domain() {
		const url = this.href.hostname;
		const parts = url.split('.');
		if (parts[0] === 'www' && parts[1] !== 'com') {
			parts.shift();
		}
		const ln = parts.length;
		let i = ln;
		const minLength = parts[parts.length - 1].length;
		let part;
		while (part = parts[--i]) {
			if (i === 0
				|| i < ln - 2
				|| part.length < minLength
				|| !this.TLDs.includes(part)
			) {
				return parts.slice(i).join('.');
			}
		}
		return null;
	}

	get containsUtm() {
		let contains = false;
		this.href.searchParams.forEach((value, name) => {
			if (name.indexOf('utm_') === 0) {
				contains = true;
			}
		});
		return contains;
	}

	get isInternalNavigation() {
		if (!this.ref || !this.href) {
			return false;
		}
		return extractDomain(this.href.hostname) === extractDomain(this.ref.hostname);
	}

	fillUtm() {
		if (!this.isInternalNavigation) {
			this.setCookie(this.hrefCookieName, this.href.href);

			if (this.ref) {
				this.setCookie(this.refCookieName, extractDomain(this.ref.hostname));
			}
			if (!this.cookies.get(this.trackingIdCookieName) && !this.replaceTrackingIdCookie()) {
				this.setCookie(this.trackingIdCookieName, newGuid());
			}
		}
	}

	replaceTrackingIdCookie() {
		const existingCookie = this.cookies.get(this.obsoleteCookieName);
		if (existingCookie) {
			this.setCookie(this.trackingIdCookieName, existingCookie);
			this.cookies.remove(this.obsoleteCookieName);
			return true;
		}
		return false;
	}

	setCookie(name, value) {
		const { expires, domain } = this;
		this.cookies.set(name, value, {
			path: '/',
			expires,
			domain,
		});
	}
}
